import Dnd from '../../grid/dnd';

export default instance => {
  instance.attachEvent('onRowDragEnd', (id, targetId) => Dnd.onRowDragEnd(id, targetId));
};
